import * as d3 from 'd3';
import { canvasLabelMeasurer } from '@ardoq/graph-labeling';
import { ARDOQ_DEFAULT_FONT_FAMILY } from '@ardoq/typography';
import { MODERNIZED_BLOCK_DIAGRAM_GROUP_PADDING as MODERNIZED_BLOCK_DIAGRAM_PADDING } from 'tabview/blockDiagram/view/yFilesExtensions/modernized/consts';
import { MODERNIZED_BLOCK_DIAGRAM_CORNER_RADIUS } from 'yfilesExtensions/styles/modernized/consts';
import { TreemapHierarchyNode, TreemapTilingMethod } from '../../types';

export const HIERARCHICAL_TREEMAP_FONT_SIZE = 12;

/** Shared with the block diagram's groups, whose card these tiles are drawn as. */
export const HIERARCHICAL_TREEMAP_PADDING = MODERNIZED_BLOCK_DIAGRAM_PADDING;
export const HIERARCHICAL_TREEMAP_CORNER_RADIUS =
  MODERNIZED_BLOCK_DIAGRAM_CORNER_RADIUS;

/** One line of a group's header, which holds its name or its grouping rule's label. */
export const HIERARCHICAL_TREEMAP_LINE_HEIGHT =
  HIERARCHICAL_TREEMAP_FONT_SIZE + 2 * HIERARCHICAL_TREEMAP_PADDING;

type TilingMethodEntry = {
  label: string;
  method: (
    node: TreemapHierarchyNode,
    x0: number,
    y0: number,
    x1: number,
    y1: number
  ) => void;
};

export const TILING_METHODS: Record<TreemapTilingMethod, TilingMethodEntry> = {
  ['binary']: { label: 'Binary', method: d3.treemapBinary },
  ['dice']: { label: 'Dice', method: d3.treemapDice },
  ['slice']: { label: 'Slice', method: d3.treemapSlice },
  ['sliceDice']: { label: 'Slice and Dice', method: d3.treemapSliceDice },
  ['squarify']: { label: 'Squarify', method: d3.treemapSquarify },
};

/**
 * How wide a tile's text is drawn, measured against the font the tiles use. Built once: the
 * measurer owns an offscreen canvas and caches what it has measured.
 */
export const measureHierarchicalTreemapLabel = canvasLabelMeasurer(
  `400 ${HIERARCHICAL_TREEMAP_FONT_SIZE}px/${HIERARCHICAL_TREEMAP_LINE_HEIGHT}px ${ARDOQ_DEFAULT_FONT_FAMILY}`
);
